






import { Component, Vue } from 'vue-property-decorator';
import { ROUTE_RECYCLE } from '@/router';

// @ts-ignore
@Component
export default class GoldAlpaca extends Vue {

  public openWool() {
    if (this.$route.name!.indexOf(ROUTE_RECYCLE) == -1) {
      this.$router.push({ name: ROUTE_RECYCLE });
    }
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

}
